import { useEffect, useState } from "react"

// libraries
import { Rating } from "@mui/material"
import StarIcon from "@mui/icons-material/Star"

// helpers
import Api from "@/_helpers/Api"

// providers
import { trans } from "@/_providers/Translation"
import Skeleton from "react-loading-skeleton"

export default function EmployeesRating() {
  const [state, setState] = useState({
    loading: true,
    data: {},
  })

  const stackedData = ["#7FE47E", "#D5EB42", "#EFCE48", "#FF893A", "#FF718B"]

  const loadData = () => {
    setState((prev) => ({ ...prev, loading: true }))

    Api.get(`analytics/technician-reviews`)
      .then((res) => {
        setState({
          loading: false,
          data: res.data,
        })
      })
      .catch(() => setState({ loading: false, data: null }))
  }

  useEffect(() => {
    loadData()
  }, [])

  function getTotalResults() {
    return Object.values(state.data?.distribution || {}).reduce(
      (sum, count) => sum + count,
      0,
    )
  }

  return (
    <div className="employees-rating">
      <div className="head">
        <h3>{trans("analytics.technicianRatings")}</h3>
      </div>
      <hr />
      <div className="body">
        {state.loading ? (
          <>
            <Skeleton height={200} count={1} />
          </>
        ) : getTotalResults() === 0 ? (
          <div
            className="alert info"
            style={{
              marginBottom: 0,
              width: "100%",
            }}
          >
            {trans("messages.noDataFound")}
          </div>
        ) : (
          <>
            <p>{trans("analytics.overallScore")}</p>
            <b>{state.data?.average_rate || 0}</b>
            <Rating
              name="text-feedback"
              value={state.data?.average_rate || 0}
              readOnly
              precision={0.1}
              emptyIcon={<StarIcon style={{ color: "#DBDBDB" }} />}
            />
            <div className="stacked-bar-wrapper">
              <div className="stacked-bar-container">
                {(state.data?.chart_data.values || []).map((item, index) => (
                  <div
                    className={`stacked-bar-segment`}
                    style={{
                      width: `${item}%`,
                      backgroundColor: stackedData[index],
                      cursor: "default",
                      opacity: 1,
                    }}
                  />
                ))}
              </div>
            </div>
            <ul className="rating-list">
              <li>
                <div>
                  <StarIcon style={{ color: "#faaf00" }} />1
                </div>
                {state.data?.distribution?.[1] || 0}
              </li>
              <li>
                <div>
                  <StarIcon style={{ color: "#faaf00" }} />2
                </div>
                {state.data?.distribution?.[2] || 0}
              </li>
              <li>
                <div>
                  <StarIcon style={{ color: "#faaf00" }} />3
                </div>
                {state.data?.distribution?.[3] || 0}
              </li>
              <li>
                <div>
                  <StarIcon style={{ color: "#faaf00" }} />4
                </div>
                {state.data?.distribution?.[4] || 0}
              </li>
              <li>
                <div>
                  <StarIcon style={{ color: "#faaf00" }} />5
                </div>
                {state.data?.distribution?.[5] || 0}
              </li>
            </ul>
          </>
        )}
      </div>
    </div>
  )
}
